import apiClient from './apiClient'; // Import the centralized apiClient
import type { AlertData } from '../store/slices/alertsSlice'; // Import AlertData type

// Re-define AlertData here if it's not exported or to avoid circular dependency issues
// For now, we assume AlertData from alertsSlice is appropriate for API response.

const getAlerts = async (game?: string, league?: string): Promise<AlertData[]> => {
  try {
    console.log(`[AlertService] Fetching alerts with game: ${game}, league: ${league}`);

    // Don't make API call if league is not provided (to avoid getting all alerts)
    if (!league) {
      console.log('[AlertService] No league provided, returning empty array');
      return [];
    }

    const response = await apiClient.get<AlertData[]>('alerts', {
      params: {
        game,
        league,
      },
    });

    console.log(`[AlertService] Received ${response.data.length} alerts from API`);
    return response.data;
  } catch (error: any) {
    // Log error or handle specific error types
    console.error('Error fetching alerts:', error);
    throw error; // Re-throw to be caught by the async thunk
  }
};

const alertService = {
  getAlerts,
};

export default alertService;
export type { AlertData }; // Re-export AlertData if needed by other services/components directly
